import React from "react";
import styles from "./RowCard.module.css";
import { MdKeyboardArrowRight } from "react-icons/md";
import Button from "../Button/Button";

interface RowCardProps {
  chipContent?: string;
  title: string;
  subtitle: string; // Optional content to show on hover
  buttonLabel: string;
  onClick: () => void;
}

const RowCard: React.FC<RowCardProps> = ({
  chipContent,
  title,
  subtitle,
  buttonLabel,
  onClick,
}) => {
  return (
    <div
      className={styles.rowCard}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
    >
      <div className={styles.leftContent}>
        {chipContent && <div className={styles.chip}>{chipContent}</div>}
        <h3 className={styles.title}>{title}</h3>
      </div>
      <div className={styles.rightContent}>
        <p className={styles.subtitle}>{subtitle}</p>
        <Button
          variant={`text-underline`}
          fullWidth={true}
          onClick={() => {
            onClick();
          }}
          className={styles.cardButton}
          rightIcon={<MdKeyboardArrowRight size={32} />}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};

export default RowCard;
